<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
       <div class="search">
          <div>
            <!-- <el-date-picker v-model="queryData.dayDate" type="date" value-format="yyyy-MM-dd" placeholder="日期" class="mr15"></el-date-picker> -->
            <!-- <el-button type="primary" @click="clickQueryReset" plain>重置</el-button> -->
            <el-button type="primary" @click="clickBack">返回</el-button>
            <el-button type="primary" @click="clickQuery">刷新</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="id" label="序号" min-width="10%"></el-table-column>
          <el-table-column prop="userid" label="用户编号" min-width="20%"></el-table-column>
          <el-table-column prop="noticeId" label="消息编号" min-width="20%"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="30%"></el-table-column>
          <el-table-column prop="Operation" label="操作" min-width="20%">
            <template slot-scope="props">
              <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                <el-link :underline="false" type="danger" icon="el-icon-delete" class="mr12" @click="ClickDelete(props.row)"></el-link>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="mt20">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="5"
            layout="prev, pager, next, sizes, jumper "
            :total="dataListnum">
          </el-pagination>
        </div>
        <!-- 分页 End -->
      </div>
      <!-- Right End -->

      <!-- 删除 -->
      <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
        <div class="confirmMsg">确定删除？</div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="NoticeNeedReadDelete" >确 定</el-button>
          <el-button @click="dialogDel = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 删除 End -->

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        terminalUserId: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false
    }
  },
  mounted () {
    this.NoticeNeedReadList()
    this.NoticeNeedReadNum()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.NoticeNeedReadList()
      this.NoticeNeedReadNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.NoticeNeedReadList()
      this.NoticeNeedReadNum()
    },
    clickQuery () {
      this.page_no = 1
      this.NoticeNeedReadList()
      this.NoticeNeedReadNum()
    },
    clickQueryReset () {
      this.clickQuery()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    NoticeNeedReadList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNeedReadNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNeedReadDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNeedReadDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeNeedReadList()
            that.NoticeNeedReadNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
